export class MapboxGLButtonControl {
  constructor({ className = '', title = '', eventHandler, position = 0 }) {
    this._className = className;
    this._title = title;
    this._eventHandler = eventHandler;
    this._position = position;
  }

  onAdd(map) {
    this._btn = document.createElement('button');
    this._btn.className = `mapboxgl-ctrl-icon ${this._className}`;
    this._btn.type = 'button';
    this._btn.title = this._title;
    this._btn.onclick = this._eventHandler;

    this._container = document.querySelectorAll(
      '.mapboxgl-ctrl-group, .mapboxgl-ctrl'
    )[this._position];
    //   this._container.className = "mapboxgl-ctrl-group mapboxgl-ctrl";
    this._container.appendChild(this._btn);

    return this._container;
  }

  onRemove() {
    if (this._container.parentNode)
      this._container.parentNode.removeChild(this._container);
    this._map = undefined;
  }
}
